module.exports = __webpack_public_path__ + "static/pumps_municipal-77949459829ce68b0f406d0f5a69e906.png";